import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ApiKeyApiService from '../../ApiServices/SettingApiServices/ApiKeyApiService';
import { useAuth } from "../Auth/AuthContext"; // Import useAuth

const ApiKeyForm = () => {
    const [apiKeys, setApiKeys] = useState([]);
    const [loading, setLoading] = useState(false);
    const { authState } = useAuth(); // Get authState from AuthContext
    const role = authState.roles;
    const user = authState.user;
    const admin = role === "Admin";
    const baseUrl = process.env.REACT_APP_BASE_URL;
    useEffect(() => {
        fetchApiKeys();
    }, []);

    const fetchApiKeys = async () => {
        try {
            setLoading(true);
            const response = await ApiKeyApiService.getApiKeys(user.id); // Ensure this is the correct API call
            setApiKeys(response.data); // Assuming response.data contains an array of API keys

            setLoading(false);
        } catch (error) {
            toast.error('Failed to fetch API keys');
            setLoading(false);
        }
    };

    const handleViewDocs = () => {
         // File ka path specify karein
      const filePath = "/ADX_Reporting_API_Documentation.pdf";
      const link = document.createElement("a");
      link.href = filePath;
      link.download = "ADX_Reporting_API_Documentation.pdf"; // File ka naam specify karein
      document.body.appendChild(link);
      link.click();
      link.remove();
    };

    const handleGenerateApiKey = async () => {
        try {
            setLoading(true);
            var obj = {
                userId: user.id,
                userName: user.userName,
                keyType: "GetBasicInfo"
            };
            const response = await ApiKeyApiService.generateKey(obj); // Ensure this is the correct API call
            if (response.data.isSuccess) {
                toast("API Generated succusfully!");
                fetchApiKeys();
            } else {
                    toast.error("something went wrong!")
            }
        } catch (error) {

        }
    };

    return (
        <>
            <ToastContainer />
            <div className="bg-white p-6 rounded-lg shadow-md mb-6" data-aos="fade-up">
                <h2 className="text-xl font-semibold mb-4">ADX Reporting</h2>
                <p className="mb-4 text-gray-600">
                    An API key for ADX reporting has not been generated. To enable programmatic API access and generate a valid token, please click on the "Generate API Key" button.
                </p>
                <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4">
                    <button
                        onClick={handleViewDocs}
                        className="flex items-center justify-center text-blue-500 border border-blue-500 hover:bg-blue-500 hover:text-white transition-colors duration-300 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2"
                    >
                        View Docs
                    </button>
                    <button
                        onClick={handleGenerateApiKey}
                        className="flex items-center justify-center text-yellow-500 border border-yellow-500 hover:bg-yellow-500 hover:text-white transition-colors duration-300 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium rounded-lg text-sm px-4 py-2"
                    >
                        Generate API Key
                    </button>
                </div>

                {/* Display API Keys */}
                <div className="mt-6">
                    <h3 className="text-lg font-semibold mb-2">Generated API Keys</h3>
                    {loading ? (
                        <p>Loading API keys...</p>
                    ) : apiKeys.length > 0 ? (
                        <ul className="border p-4 rounded-md bg-gray-100">
                            {apiKeys.map((apiKey, index) => (
                                <>
                                    <li key={index} className="text-gray-700 mb-2">
                                        <span className="font-medium">Key {index + 1}:</span> {apiKey.key}
                                    </li>
                                    <li key={index} className="text-gray-700 mb-2">
                                        <span className="font-medium">url {index + 1}:</span> {baseUrl + apiKey.url}
                                    </li>
                                </>
                            ))}
                        </ul>
                    ) : (
                        <p className="text-gray-500">No API keys found.</p>
                    )}
                </div>
            </div>
        </>
    );
};

export default ApiKeyForm;
